import { useState } from 'react';
import Reveal from '@/pages/zz-review/components/Reveal';

const faqs = [
  {
    q: '這本書是宗教書嗎？',
    a: '本書不屬於特定宗教教義，也不要求讀者接受特定信仰。國家圖書館主題詞為「成功法；靈修」。全書將焦點放在身體、關係、工作、金錢、決策與日常實踐。',
  },
  {
    q: '什麼是 RG Portal？需要另外付費嗎？',
    a: 'RG Portal 是把書中練習帶入日常事件的數位實踐入口。每本募資實體書附贈導航卡，可免費使用 3 次 AI Angel 引導與 Evidence 建立體驗。體驗完成後，讀者可自主決定是否採用後續工具，沒有強制購買。',
  },
  {
    q: '為什麼募資價沒有大幅折扣？',
    a: '本專案首次公開一條以回歸中軸、一年築基與現實結果促進入世成功的實踐路徑，並提出「人類是否可能帶著肉身站上 5D 頂端？」作為交由生命與集體實踐驗證的命題。作者以自身長期生命成長歷程為見證，希望讀者以作品與實踐價值作為支持理由，開始行動、體驗並留下可回看的 Evidence，而不是以跳樓折價刺激消費。募資回饋已包含臺灣配送與首發實踐入口。',
  },
  {
    q: '作者會露面或親簽嗎？',
    a: '本專案不提供作者親簽或露面活動。我們希望信任建立在書籍內容、實踐方法與讀者自己的生命結果上。',
  },
  {
    q: '什麼時候可以收到書？',
    a: '預計 2026 年 11 月中旬前完成臺灣批次寄送；海外件依物流工作天順延。若平台審核、印刷產能或物流影響時程，將透過專案更新公告。',
  },
  {
    q: '可以寄送港澳或其他海外地區嗎？',
    a: '可以。結帳時將依地區加收國際運費。當地關稅、稅費與偏遠地區附加費，如有發生，由贊助者負擔。',
  },
  {
    q: '企業 10 本組包含顧問服務嗎？',
    a: '不包含。回饋內容為 10 冊實體書、90 日實踐入口指南與後續諮詢登記資格。工作坊、組織評估或客製導入將另行評估與報價。',
  },
  {
    q: '會同時發行電子書嗎？',
    a: '電子書將以獨立版本與電子書 ISBN 發行，通路與上架日將另行公告；本次嘖嘖核心回饋為繁體中文紙本書。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-10">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              常見問題
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              你可能想問
            </h2>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <div className="space-y-3">
            {faqs.map((f, i) => {
              const open = openIndex === i;
              return (
                <div
                  key={f.q}
                  className="rounded-lg border border-background-200/70 bg-background-100 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(open ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left cursor-pointer"
                  >
                    <span
                      className="text-sm md:text-base text-foreground-900 font-medium"
                      style={{ fontFamily: 'var(--font-heading)' }}
                    >
                      {f.q}
                    </span>
                    <span className="w-6 h-6 flex items-center justify-center text-foreground-400 shrink-0">
                      <i className={`ri-${open ? 'subtract' : 'add'}-line text-lg`} />
                    </span>
                  </button>
                  {open && (
                    <div className="px-5 md:px-6 pb-5">
                      <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                        {f.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}